import { css } from 'lit';

export const style = css`
  .button-container-iconic {
    text-align: center;
  }

  .fs-button-iconic.next-button {
    margin-top: 0.5rem;
  }

  @media (max-width: 48em) {
    .fs-button-iconic.next-button {
      margin-top: 0.5rem;
      min-width: 100%;
    }
  }
`;
